/* TROTTO — interacciones propias (vanilla, sin librerías) */
(function () {
  'use strict';
  document.documentElement.classList.add('mt-js');
  var reduce = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  /* ---------- Reveals con un único IntersectionObserver ---------- */
  var io = null;
  function observar(root) {
    var els = (root || document).querySelectorAll('[data-mt-reveal], .mt-split, .mt-resalte');
    if (reduce || !('IntersectionObserver' in window)) {
      els.forEach(function (el) { el.classList.add('mt-in'); });
      return;
    }
    if (!io) {
      io = new IntersectionObserver(function (entries) {
        entries.forEach(function (e) {
          if (e.isIntersecting) { e.target.classList.add('mt-in'); io.unobserve(e.target); }
        });
      }, { threshold: 0.14, rootMargin: '0px 0px -6% 0px' });
    }
    els.forEach(function (el) { if (!el.classList.contains('mt-in')) io.observe(el); });
  }

  /* ---------- Titulares que suben palabra a palabra ---------- */
  function initSplit(root) {
    (root || document).querySelectorAll('.mt-split:not([data-mt-listo])').forEach(function (el) {
      el.setAttribute('data-mt-listo', '');
      var i = 0;
      function recorrer(nodo) {
        Array.prototype.slice.call(nodo.childNodes).forEach(function (hijo) {
          if (hijo.nodeType === 3) {
            var frag = document.createDocumentFragment();
            hijo.textContent.split(/(\s+)/).forEach(function (parte) {
              if (!parte) return;
              if (/^\s+$/.test(parte)) { frag.appendChild(document.createTextNode(' ')); return; }
              var w = document.createElement('span'); w.className = 'mt-w';
              var s = document.createElement('span'); s.textContent = parte; s.style.setProperty('--i', i++);
              w.appendChild(s); frag.appendChild(w);
            });
            nodo.replaceChild(frag, hijo);
          } else if (hijo.nodeType === 1 && !hijo.matches('svg')) {
            if (hijo.classList.contains('mt-resalte')) {
              var w = document.createElement('span'); w.className = 'mt-w'; w.style.overflow = 'visible';
              var s = document.createElement('span'); s.style.setProperty('--i', i++);
              hijo.parentNode.insertBefore(w, hijo); s.appendChild(hijo); w.appendChild(s);
            } else { recorrer(hijo); }
          }
        });
      }
      recorrer(el);
    });
  }

  /* ---------- Parallax suave (solo transform) ---------- */
  var parallax = [];
  function initParallax(root) {
    parallax = Array.prototype.slice.call(document.querySelectorAll('[data-mt-parallax]'));
  }
  var ticking = false;
  function onScroll() {
    if (ticking) return; ticking = true;
    requestAnimationFrame(function () {
      var vh = window.innerHeight;
      if (!reduce) {
        parallax.forEach(function (el) {
          var r = el.parentElement.getBoundingClientRect();
          if (r.bottom < -100 || r.top > vh + 100) return;
          var k = parseFloat(el.getAttribute('data-mt-parallax')) || 0.12;
          var p = (r.top + r.height / 2 - vh / 2) / vh;
          el.style.transform = 'translate3d(0,' + (p * k * -100).toFixed(2) + 'px,0)';
        });
      }
      document.querySelectorAll('[data-mt-trazo]').forEach(function (sec) {
        var r = sec.getBoundingClientRect();
        var prog = Math.min(1, Math.max(0, (vh * 0.85 - r.top) / (r.height * 0.8)));
        sec.style.setProperty('--mt-prog', (1400 * (1 - prog)).toFixed(0));
      });
      document.querySelectorAll('[data-mt-gira]').forEach(function (el) {
        var r = el.getBoundingClientRect();
        if (r.bottom < 0 || r.top > vh) return;
        var p = (r.top + r.height / 2 - vh / 2) / vh;
        el.style.transform = reduce ? '' : 'rotate(' + (p * -14).toFixed(2) + 'deg) translate3d(0,' + (p * 30).toFixed(1) + 'px,0)';
      });
      ticking = false;
    });
  }

  /* ---------- Cifras que cuentan ---------- */
  function initContadores(root) {
    var els = (root || document).querySelectorAll('[data-mt-count]:not([data-mt-listo])');
    if (!els.length) return;
    var obs = new IntersectionObserver(function (entries) {
      entries.forEach(function (e) {
        if (!e.isIntersecting) return;
        obs.unobserve(e.target);
        var el = e.target, fin = parseFloat(el.getAttribute('data-mt-count')) || 0;
        var dec = (String(fin).split('.')[1] || '').length;
        var coma = /^(es|fr|de|it|pt|nl)/.test(document.documentElement.lang || '');
        var fmt = function (n) { var s = n.toFixed(dec); return coma ? s.replace('.', ',') : s; };
        if (reduce) { el.textContent = fmt(fin); return; }
        var t0 = null, dur = 1800;
        function paso(t) {
          if (!t0) t0 = t;
          var k = Math.min(1, (t - t0) / dur), v = fin * (1 - Math.pow(1 - k, 4));
          el.textContent = fmt(v);
          if (k < 1) requestAnimationFrame(paso);
        }
        requestAnimationFrame(paso);
      });
    }, { threshold: 0.5 });
    els.forEach(function (el) { el.setAttribute('data-mt-listo', ''); el.textContent = '0'; obs.observe(el); });
  }

  /* ---------- Comparador antes/después ---------- */
  function initComparador(root) {
    (root || document).querySelectorAll('.mt-comp__visor:not([data-mt-listo])').forEach(function (v) {
      v.setAttribute('data-mt-listo', '');
      var r = v.querySelector('.mt-comp__rango');
      if (!r) return;
      function set(val) { v.style.setProperty('--pos', val + '%'); }
      r.addEventListener('input', function () { set(r.value); });
      set(r.value);
      // pequeño "guiño" automático al entrar en pantalla para enseñar que se arrastra
      if (reduce || !('IntersectionObserver' in window)) return;
      var o = new IntersectionObserver(function (es) {
        if (!es[0].isIntersecting) return; o.disconnect();
        var ini = parseFloat(r.value), t0 = null;
        function anim(t) {
          if (!t0) t0 = t; var k = (t - t0) / 1600; if (k > 1) { set(ini); r.value = ini; return; }
          var val = ini + Math.sin(k * Math.PI * 2) * 14; set(val); requestAnimationFrame(anim);
        }
        setTimeout(function () { requestAnimationFrame(anim); }, 500);
      }, { threshold: 0.6 });
      o.observe(v);
    });
  }

  /* ---------- Tarjetas que se inclinan hacia el cursor ---------- */
  function initTilt(root) {
    if (reduce || window.matchMedia('(hover: none)').matches) return;
    (root || document).querySelectorAll('[data-mt-tilt]:not([data-mt-listo])').forEach(function (c) {
      c.setAttribute('data-mt-listo', '');
      var f = parseFloat(c.getAttribute('data-mt-tilt')) || 6;
      c.addEventListener('mousemove', function (e) {
        var r = c.getBoundingClientRect(), x = (e.clientX - r.left) / r.width - 0.5, y = (e.clientY - r.top) / r.height - 0.5;
        c.style.transform = 'rotateY(' + (x * f) + 'deg) rotateX(' + (-y * f) + 'deg) translateZ(0)';
      });
      c.addEventListener('mouseleave', function () { c.style.transform = ''; });
    });
  }

  /* ---------- Carrusel arrastrable ---------- */
  function initCarrusel(root) {
    (root || document).querySelectorAll('[data-mt-carrusel]:not([data-mt-listo])').forEach(function (sec) {
      sec.setAttribute('data-mt-listo', '');
      var pista = sec.querySelector('.mt-usos__pista');
      if (!pista) return;
      var paso = function () { var c = pista.querySelector('.mt-uso'); return c ? c.getBoundingClientRect().width + 20 : 300; };
      sec.querySelectorAll('[data-mt-dir]').forEach(function (b) {
        b.addEventListener('click', function () { pista.scrollBy({ left: paso() * parseInt(b.getAttribute('data-mt-dir'), 10), behavior: 'smooth' }); });
      });
      var abajo = false, x0 = 0, s0 = 0, movido = false;
      pista.addEventListener('pointerdown', function (e) {
        if (e.pointerType !== 'mouse') return;
        abajo = true; movido = false; x0 = e.clientX; s0 = pista.scrollLeft; pista.classList.add('mt-arrastrando');
      });
      window.addEventListener('pointermove', function (e) {
        if (!abajo) return; var dx = e.clientX - x0; if (Math.abs(dx) > 4) movido = true; pista.scrollLeft = s0 - dx;
      });
      window.addEventListener('pointerup', function () {
        if (!abajo) return; abajo = false; pista.classList.remove('mt-arrastrando');
      });
      pista.addEventListener('click', function (e) { if (movido) { e.preventDefault(); e.stopPropagation(); } }, true);
    });
  }

  /* ---------- Selector de colores (portada) ---------- */
  function initColores(root) {
    (root || document).querySelectorAll('.mt-colores:not([data-mt-listo])').forEach(function (sec) {
      sec.setAttribute('data-mt-listo', '');
      var btns = sec.querySelectorAll('.mt-muestra'), imgs = sec.querySelectorAll('.mt-colores__escena img');
      btns.forEach(function (b, i) {
        b.addEventListener('click', function () {
          btns.forEach(function (x) { x.setAttribute('aria-pressed', x === b ? 'true' : 'false'); });
          imgs.forEach(function (im, j) { im.classList.toggle('mt-activa', j === i); });
          sec.setAttribute('data-activo', i);
          var link = sec.querySelector('[data-mt-link-color]');
          if (link && b.dataset.url) link.href = b.dataset.url;
        });
      });
    });
  }

  /* ---------- FAQ con animación de altura ---------- */
  function initFaq(root) {
    (root || document).querySelectorAll('.mt-faq__item:not([data-mt-listo])').forEach(function (d) {
      d.setAttribute('data-mt-listo', '');
      var s = d.querySelector('summary'), c = d.querySelector('.mt-faq__resp');
      if (!s || !c || reduce) return;
      s.addEventListener('click', function (e) {
        e.preventDefault();
        if (d.open) {
          c.animate([{ height: c.offsetHeight + 'px', opacity: 1 }, { height: '0px', opacity: 0 }], { duration: 380, easing: 'cubic-bezier(.22,1,.36,1)' }).onfinish = function () { d.open = false; };
        } else {
          d.open = true; var h = c.offsetHeight;
          c.animate([{ height: '0px', opacity: 0 }, { height: h + 'px', opacity: 1 }], { duration: 480, easing: 'cubic-bezier(.22,1,.36,1)' });
        }
      });
    });
  }

  /* ---------- Página de producto ---------- */
  function initProducto(root) {
    (root || document).querySelectorAll('[data-mt-producto]:not([data-mt-listo])').forEach(function (sec) {
      sec.setAttribute('data-mt-listo', '');
      var datosEl = sec.querySelector('[data-mt-variantes]');
      var variantes = datosEl ? JSON.parse(datosEl.textContent) : [];
      var principal = sec.querySelector('.mt-pp__principal');
      var imgP = principal ? principal.querySelector('img') : null;
      var minis = sec.querySelectorAll('.mt-pp__mini');
      var form = sec.querySelector('form[action*="/cart/add"]');
      var inputId = form ? form.querySelector('input[name="id"]') : null;
      var btn = sec.querySelector('[data-mt-add]');
      var btnTxt = btn ? btn.querySelector('span') : null;
      var precioEl = sec.querySelector('[data-mt-precio]'), antesEl = sec.querySelector('[data-mt-antes]');
      var barraPrecio = document.querySelector('[data-mt-barra-precio]');
      var formato = sec.getAttribute('data-mt-moneda') || '{{amount_with_comma_separator}} €';

      function dinero(c) {
        var n = (c / 100).toFixed(2), partes = n.split('.');
        var miles = partes[0].replace(/\B(?=(\d{3})+(?!\d))/g, '.');
        return formato.replace(/\{\{\s*amount_with_comma_separator\s*\}\}/, miles + ',' + partes[1])
          .replace(/\{\{\s*amount\s*\}\}/, (c / 100).toFixed(2))
          .replace(/\{\{\s*amount_no_decimals\s*\}\}/, Math.round(c / 100));
      }
      function mostrar(src, srcset, idx) {
        if (!imgP || !src) return;
        imgP.classList.add('mt-saliendo');
        setTimeout(function () {
          imgP.src = src; if (srcset) imgP.srcset = srcset;
          imgP.onload = function () { imgP.classList.remove('mt-saliendo'); };
          setTimeout(function () { imgP.classList.remove('mt-saliendo'); }, 400);
        }, 180);
        minis.forEach(function (m, j) { m.setAttribute('aria-current', j === idx ? 'true' : 'false'); });
      }
      minis.forEach(function (m, i) {
        m.addEventListener('click', function () { mostrar(m.dataset.src, m.dataset.srcset, i); });
      });
      if (principal && window.matchMedia('(hover: hover)').matches) {
        principal.addEventListener('mousemove', function (e) {
          var r = principal.getBoundingClientRect();
          principal.style.setProperty('--zx', ((e.clientX - r.left) / r.width * 100) + '%');
          principal.style.setProperty('--zy', ((e.clientY - r.top) / r.height * 100) + '%');
        });
        principal.addEventListener('click', function () { principal.classList.toggle('mt-zoom'); });
        principal.addEventListener('mouseleave', function () { principal.classList.remove('mt-zoom'); });
      }

      function actualizar() {
        var elegidas = [];
        sec.querySelectorAll('.mt-pp__opcion').forEach(function (fs) {
          var c = fs.querySelector('input:checked'); elegidas.push(c ? c.value : null);
          var span = fs.querySelector('legend span'); if (span && c) span.textContent = c.value;
        });
        var v = variantes.find(function (x) { return x.options.every(function (o, i) { return o === elegidas[i]; }); });
        if (!v) { if (btn) { btn.disabled = true; btnTxt.textContent = btn.dataset.noDisp; } return; }
        if (inputId) inputId.value = v.id;
        if (precioEl) precioEl.textContent = dinero(v.price);
        precioPacks(v.price);
        if (barraPrecio) barraPrecio.textContent = dinero(v.price);
        if (antesEl) { antesEl.textContent = v.compare_at_price > v.price ? dinero(v.compare_at_price) : ''; }
        if (btn) { btn.disabled = !v.available; btnTxt.textContent = v.available ? btn.dataset.txt : btn.dataset.agotado; }
        if (v.featured_media && v.featured_media.id) {
          var i = Array.prototype.findIndex.call(minis, function (m) { return m.dataset.mediaId == v.featured_media.id; });
          if (i > -1) mostrar(minis[i].dataset.src, minis[i].dataset.srcset, i);
        }
        if (window.history.replaceState && sec.hasAttribute('data-mt-url')) {
          var u = new URL(window.location.href); u.searchParams.set('variant', v.id); window.history.replaceState({}, '', u.toString());
        }
      }
      sec.querySelectorAll('.mt-pp__opcion input').forEach(function (inp) { inp.addEventListener('change', actualizar); });

      var cant = sec.querySelector('.mt-pp__cantidad input');
      sec.querySelectorAll('[data-mt-cant]').forEach(function (b) {
        b.addEventListener('click', function () { cant.value = Math.max(1, (parseInt(cant.value, 10) || 1) + parseInt(b.dataset.mtCant, 10)); });
      });

      // Packs por cantidad: tarjetas 1/2/3 con color por unidad
      var packs = sec.querySelector('[data-mt-packs]');
      var qtyInput = sec.querySelector('.mt-pp__cantidad input');
      function packActivo() { return packs ? packs.querySelector('.mt-pack.is-activo') : null; }
      function precioPacks(precio) {
        if (!packs) return;
        packs.querySelectorAll('.mt-pack').forEach(function (c) {
          var n = +c.dataset.n, d = +c.dataset.d, completo = precio * n;
          var t = c.querySelector('[data-mt-pack-total]'), s = c.querySelector('[data-mt-pack-completo]');
          var ahorro = Math.round(completo * d / 100); // igual que el descuento porcentual de Shopify
          var total = completo - ahorro;
          if (t) t.textContent = dinero(total);
          var ud = c.querySelector('[data-mt-pack-ud]'), ah = c.querySelector('[data-mt-pack-ahorro]');
          if (ud) ud.textContent = dinero(Math.round(total / n));
          if (ah) ah.textContent = dinero(ahorro);
          if (s) s.textContent = dinero(completo);
        });
      }
      if (packs) {
        sec.classList.add('mt-pp--packs');
        packs.querySelectorAll('.mt-pack').forEach(function (c) {
          var radio = c.querySelector('input');
          function elegir() {
            packs.querySelectorAll('.mt-pack').forEach(function (x) { x.classList.toggle('is-activo', x === c); });
            radio.checked = true;
            if (qtyInput) qtyInput.value = c.dataset.n;
            sec.classList.toggle('mt-pp--pack-multi', +c.dataset.n > 1 && !!c.querySelector('[data-mt-unidad]'));
          }
          radio.addEventListener('change', elegir);
          c.querySelectorAll('.mt-pack__color').forEach(function (b) {
            b.addEventListener('click', function (e) {
              e.preventDefault();
              b.closest('[data-mt-unidad]').querySelectorAll('.mt-pack__color').forEach(function (x) { x.setAttribute('aria-pressed', x === b ? 'true' : 'false'); });
              elegir();
            });
          });
        });
      }
      // Si llega desde el bloque de ofertas (?pack=2 o ?pack=3), deja ese pack elegido
      if (packs) {
        var pedido = new URLSearchParams(window.location.search).get('pack');
        var elegido = pedido && packs.querySelector('.mt-pack[data-n="' + pedido + '"] input');
        if (elegido) { elegido.checked = true; elegido.dispatchEvent(new Event('change', { bubbles: true })); }
      }
      function lineasCarrito() {
        var c = packActivo(), n = c ? +c.dataset.n : Math.max(1, parseInt(qtyInput && qtyInput.value, 10) || 1);
        var unidades = c ? c.querySelectorAll('[data-mt-unidad]') : [];
        if (n > 1 && unidades.length) {
          var cuenta = {};
          unidades.forEach(function (u) { var b = u.querySelector('[aria-pressed="true"]'); if (b) cuenta[b.dataset.id] = (cuenta[b.dataset.id] || 0) + 1; });
          return Object.keys(cuenta).map(function (id) { return { id: +id, quantity: cuenta[id] }; });
        }
        return [{ id: +inputId.value, quantity: n }];
      }

      // Añadir al carrito sin salir de la página (abre el cajón de Dawn si existe)
      if (form && btn) {
        form.addEventListener('submit', function (e) {
          e.preventDefault();
          var cajon = document.querySelector('cart-drawer');
          var raiz = window.Shopify && Shopify.routes ? Shopify.routes.root : '/';
          var cuerpo = { items: lineasCarrito() };
          if (cajon && typeof cajon.renderContents === 'function') {
            cuerpo.sections = cajon.getSectionsToRender().map(function (s) { return s.id; });
            cuerpo.sections_url = window.location.pathname;
          }
          btn.disabled = true; btn.classList.add('mt-cargando');
          fetch(raiz + 'cart/add.js', {
            method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json', 'X-Requested-With': 'XMLHttpRequest' }, body: JSON.stringify(cuerpo)
          }).then(function (r) { return r.json(); }).then(function (res) {
            if (res.status) { alert(res.description || res.message); return; }
            if (cajon && res.sections) {
              var primero = (res.items && res.items[0]) || {};
              res.id = primero.id; res.key = primero.key;
              cajon.classList.remove('is-empty');
              cajon.renderContents(res);
            } else { window.location.href = raiz + 'cart'; }
          }).catch(function () { window.location.href = raiz + 'cart'; })
            .finally(function () { btn.disabled = false; btn.classList.remove('mt-cargando'); });
        });
      }

      // Barra fija de compra al bajar
      var barra = document.querySelector('.mt-barra');
      if (barra && btn && 'IntersectionObserver' in window) {
        new IntersectionObserver(function (es) {
          var fuera = !es[0].isIntersecting && es[0].boundingClientRect.top < 0;
          barra.classList.toggle('mt-visible', fuera);
        }).observe(btn);
        var bb = barra.querySelector('button');
        if (bb) bb.addEventListener('click', function () { btn.click(); });
      }
    });
  }

  /* ---------- Copiar el correo de contacto ---------- */
  function initCopiar(root) {
    (root || document).querySelectorAll('[data-mt-copiar]:not([data-mt-listo])').forEach(function (b) {
      b.setAttribute('data-mt-listo', '');
      var original = b.textContent;
      b.addEventListener('click', function () {
        var hecho = function () { b.textContent = b.dataset.ok || '✓'; setTimeout(function () { b.textContent = original; }, 1800); };
        if (navigator.clipboard) navigator.clipboard.writeText(b.dataset.mtCopiar).then(hecho, hecho); else hecho();
      });
    });
  }

  /* ---------- "Añadir otra" en el aviso de packs del carrito ---------- */
  document.addEventListener('click', function (e) {
    var b = e.target.closest && e.target.closest('[data-mt-upsell-add]');
    if (!b) return;
    e.preventDefault();
    b.disabled = true;
    var cajon = document.querySelector('cart-drawer');
    var raiz = window.Shopify && Shopify.routes ? Shopify.routes.root : '/';
    var cuerpo = { items: [{ id: +b.getAttribute('data-mt-upsell-add'), quantity: 1 }] };
    var enCarrito = !!document.getElementById('main-cart-items');
    if (cajon && !enCarrito && typeof cajon.renderContents === 'function') {
      cuerpo.sections = cajon.getSectionsToRender().map(function (s) { return s.id; });
      cuerpo.sections_url = window.location.pathname;
    }
    fetch(raiz + 'cart/add.js', { method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' }, body: JSON.stringify(cuerpo) })
      .then(function (r) { return r.json(); })
      .then(function (res) {
        if (cuerpo.sections && res.sections) { var p = (res.items && res.items[0]) || {}; res.id = p.id; res.key = p.key; cajon.renderContents(res); }
        else { window.location.reload(); }
      })
      .catch(function () { window.location.reload(); });
  });

  function initTodo(root) {
    initCopiar(root);
    initSplit(root); observar(root); initContadores(root); initComparador(root); initTilt(root);
    initCarrusel(root); initColores(root); initFaq(root); initProducto(root); initParallax(root); onScroll();
  }

  document.addEventListener('DOMContentLoaded', function () { initTodo(document); });
  window.addEventListener('scroll', onScroll, { passive: true });
  window.addEventListener('resize', onScroll);
  // Editor de Shopify: reactivar al añadir o editar secciones
  document.addEventListener('shopify:section:load', function (e) { initTodo(e.target); e.target.querySelectorAll('[data-mt-reveal], .mt-split, .mt-resalte').forEach(function (el) { el.classList.add('mt-in'); }); });
})();
